import { Box, Icon, IframeLayout, SeparatorCurve, SeparatorImg, chooseColor } from 'vopay';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLayout } from '@/providers/Layout.provider';
import { useToken } from '@/providers/Token.provider';
import styles from './GenerateError.module.scss';
import { Title, Button } from 'UI';

const GenerateError: FC = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'GenerateError' });
  const { layout, hasBackButton, color, setLayoutInfo } = useLayout();
  const { token } = useToken();

  useEffect(() => {
    setLayoutInfo(
      chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  const handleBackToPaymentOptions = () => {
    history.goBack();
  };

  return (
    <IframeLayout
      separator={
        layout === 'img' ? (
          <SeparatorImg width={100} height={110} fill={color} />
        ) : layout === 'curve' ? (
          <SeparatorCurve width={140} height={110} fill={color} />
        ) : (
          <></>
        )
      }
      image={<></>}
      hasBackButton={hasBackButton}
      content={
        <div className={styles.container}>
          <Box flx="col" gapSize="33px" width="100%" ai="center">
            <div className={styles.iconContainer}>
              <Icon icon="errorRed2" color="none" width="62px" height="62px" />
            </div>

            <Title level="1">{t('title', { defaultValue: 'Something went wrong' })}</Title>

            <div className={styles.description}>
              {t('descriptionLine1', { defaultValue: "We're having trouble processing your request." })}
              <br />
              {t('descriptionLine2', { defaultValue: 'Please try again in a few minutes.' })}
            </div>

            <Box flx="col" jc="center">
              <Button
                id="back-to-payment-options"
                colorScheme="primary"
                type="button"
                onClick={handleBackToPaymentOptions}
              >
                {t('backButton', { defaultValue: 'Back to Payment Options' })}
              </Button>
            </Box>
          </Box>
        </div>
      }
    />
  );
};

export default GenerateError;
